var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDayNotClaimedInvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 19,
    viewBox: "0 0 74 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 36.8,
    y1: 46.421,
    x2: 36.8,
    y2: -51.612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BD2333",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26253F",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 -0 -1 74 19)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.35866 18.6L0 11.7705L0 0L73.6 0L73.6 11.7705L67.2413 18.6L51.8848 18.6L21.7152 18.6L6.35866 18.6L6.35866 18.6Z",
    fill: "url(#gradient_1)",
    strokeWidth: 0.4,
    stroke: "#BD2333",
    transform: "translate(0.2 0.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDayNotClaimedInvert);
export default __webpack_public_path__ + "static/media/iconDayNotClaimed_invert.970dc0449ffb3d30f8621558d1ed16bf.svg";
export { ForwardRef as ReactComponent };